import { forwardRef, type InputHTMLAttributes } from "react";

interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
	label?: string;
	description?: string;
}

const Toggle = forwardRef<HTMLInputElement, ToggleProps>(({ label, description, id, className = "", disabled, ...props }, ref) => {
	const inputId = id || props.name;

	return (
		<label htmlFor={inputId} className={`flex items-start gap-3 cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}>
			<div className="relative shrink-0 mt-0.5">
				<input ref={ref} type="checkbox" id={inputId} disabled={disabled} className="sr-only peer" {...props} />
				<div className="w-8 h-5 bg-gray-200 rounded-full peer-checked:bg-gray-800 peer-focus:ring-2 peer-focus:ring-gray-800 peer-focus:ring-offset-1 transition-colors" />
				<div className="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-sm peer-checked:translate-x-3 transition-transform" />
			</div>
			{(label || description) && (
				<div className="flex-1">
					{label && <span className="block text-sm font-medium text-primary">{label}</span>}
					{description && <span className="block text-xs text-tertiary mt-0.5">{description}</span>}
				</div>
			)}
		</label>
	);
});

Toggle.displayName = "Toggle";

export default Toggle;
